import { homeAtom } from "./home";
import homeApi from "@/api/homeApi";
const lifestyleConfig = [
  { ID: 50, icon: "dk_Dressing_1" },
  { ID: 10, icon: "dk_Travel_1" },
  { ID: 25, icon: "dk_Flu_1" },
  { ID: 29, icon: "dk_Outdoor_acticities_1" },
  { ID: 48, icon: "dk_Dry_Skin_Forecast_1" },
  { ID: 51, icon: "dk_Suitabl_for_car_washing_1" },
]; // 具体筛选出哪些ID 等产品决定
const lifestyleDataAtom = atom<any>([]);
const queryLifeStyleAtom = atom(null, async (get, set, newParams: any) => {
  try {
    const locSelCity = LocalStorage.getItem("SELECT_CITY");
    const locInfo = LocalStorage.getItem("INFO");
    const homeData = get(homeAtom);
    newParams.keyId = newParams.keyId || locSelCity?.Key || homeData?.data?.info?.key || locInfo?.key;
    const resData = await homeApi.queryDetailIndices(newParams);
    const apiIndices = resData?.data?.indices;
    if (apiIndices) {
      const filteredData = lifestyleConfig
        .map(lifestyleItem => {
          const apiItem = apiIndices.find((item: any) => item.ID === lifestyleItem.ID);
          if (apiItem) {
            return {
              ...apiItem,
              icon: lifestyleItem.icon,
            };
          }
          return null;
        })
        .filter(item => item !== null);

      set(lifestyleDataAtom, filteredData);
    }

    return resData;
  } catch (error) {
    console.error("查询每日数据失败：", error);
    throw error;
  }
});

export { lifestyleDataAtom, queryLifeStyleAtom, lifestyleConfig };
